import { type ReactNode } from 'react';

import type { AnalyticsEvent } from '../config';

export enum ProviderId {
  Yandex = 'yandex',
}

export interface AnalyticsProvider {
  id: ProviderId;
  track: (event: AnalyticsEvent) => void;
  identify?: (userGroupId: string) => void;
  getScript?: () => ReactNode;
}
